export default __webpack_public_path__ + "static/media/microchip.083ef8d7.svg";